import { transparentChecker } from "./utils.js";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
import { isLight } from "@givebutter/util";
//#region src/color-picker/Swatch.tsx
const Swatch = ({ color, className, style = {}, ...rest }) => {
	const isLightColor = isLight(color);
	const isTransparent = color?.toLowerCase() === "transparent";
	return /* @__PURE__ */ jsx("span", {
		className: twMerge("inline-block size-5 rounded-lg", (isLightColor || isTransparent) && "border border-gray-300", className),
		style: {
			...style,
			background: isTransparent ? transparentChecker : color
		},
		...rest
	});
};
const getFocusColor = (color) => {
	return isLight(color) || color?.toLowerCase() === "transparent" ? "#d1d1d6" : color;
};
//#endregion
export { Swatch, getFocusColor };
